import React from "react";
import LandingSimpleSection from "@insightfulscience/atomic-react/LandingElement/SimpleSection";
import { Col, Row } from "@insightfulscience/atomic-react/Grid";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";

const SectionCopyright = () => (
	<LandingSimpleSection isBorderNone spacing={{ pt: 10, pb: 24 }}>
		<LandingSimpleSection.Body>
			<Row utility={{ justify: "center" }}>
				<Col lg={10}>
					<Paragraph sx={{ fontColor: "black--20", textAlign: "center" }}>
						The maps, notes, and annotations in the zip file on this page are copyrighted material.
						This material may be used without restriction by academic, nonprofit, and governmental
						entities, except that the source must be cited as ’’www.snapgene.com/resources’’.
						Commercial entities must contact GraphPad Software LLC for permission and terms of use.
					</Paragraph>
				</Col>
			</Row>
		</LandingSimpleSection.Body>
	</LandingSimpleSection>
);

export default SectionCopyright;
